import { _wxConfig } from "../api/lib";

const updateUpdate = function (link) {
  let url = window._wxConfigData.iosConfigUrl // location.href.split("#")[0];
  // const u = window.navigator.userAgent, app = window.navigator.appVersion;
  // const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  // if(isIOS){
  //   url = window._wxConfigData.iosConfigUrl
  // }
  return _wxConfig(encodeURIComponent(url)).then((d) => {
    let data = d.data;
    window._wxConfigData._appId = data.appId;
    if (!window.wx) {
      console.log("2G网络太慢，导致wx对象读不出来，跳过");
      return false;
    }
    wx.config({
      debug: data.debug,
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: [
        'checkJsApi',/*判断当前客户端版本是否支持指定JS接口*/
        // 'updateTimelineShareData',/*分享到朋友圈*/
        // 'updateAppMessageShareData',/*分享给朋友*/
        'onMenuShareTimeline', // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）
        'onMenuShareAppMessage', //获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃） 
        // 'onMenuShareQQ',/*分享到QQ*/
        // 'onMenuShareWeibo',/*分享到腾讯微博*/
        // 'onMenuShareQZone',/*分享到QQ空间*/
        // 'hideMenuItems', /*批量隐藏功能按钮接口*/
        // 'showMenuItems',  /*批量显示功能按钮接口*/
        // 'hideAllNonBaseMenuItem',   /*隐藏所有非基础按钮接口*/
        // 'showAllNonBaseMenuItem',   /*显示所有功能按钮接口*/
        // 'translateVoice',   /*识别音频并返回识别结果接口*/
        // 'startRecord',  /*开始录音接口*/
        // 'stopRecord',  /*停止录音接口*/
        // 'onVoiceRecordEnd',  /*监听录音自动停止接口*/
        // 'playVoice',  /*播放语音接口*/
        // 'pauseVoice',  /*暂停播放接口*/
        // 'stopVoice',  /*停止播放接口*/
        // 'uploadVoice',  /*上传语音接口*/
        // 'onVoicePlayEnd',  /*监听语音播放完毕接口*/
        // 'downloadVoice',  /*下载语音接口*/
        // 'chooseImage',  /*拍照或从手机相册中选图接口*/
        // 'previewImage',   /*预览图片接口*/
        // 'uploadImage',  /*上传图片接口*/
        // 'downloadImage',  /*下载图片接口*/
        'getNetworkType',  /*获取网络状态接口*/
        // 'openLocation',  /*使用微信内置地图查看位置接口*/
        // 'getLocation',   /*获取地理位置接口*/
        // 'hideOptionMenu',  /*隐藏右上角菜单接口*/
        // 'showOptionMenu',  /*显示右上角菜单接口*/
        // 'closeWindow',  /*关闭当前网页窗口接口*/
        'scanQRCode',  /*调起微信扫一扫接口*/
        'chooseWXPay'  /*发起一个微信支付请求*/
        // 'openProductSpecificView',  /*跳转微信商品页接口*/
        // 'addCard',  /*批量添加卡券接口*/
        // 'chooseCard',  /*拉取适用卡券列表并获取用户选择信息*/
        // 'openCard'  /*查看微信卡包中的卡券接口*/
      ]
    });
    wx.ready(function (r) {
      // wx.updateTimelineShareData({
      //   title: __shareData.title || "title",
      //   desc: __shareData.desc || "desc",
      //   link: __shareData.link || "link",
      //   imgUrl: __shareData.imgUrl || "imgUrl",
      //   success: function (res) {
      //     console.log('updateTimelineShareData success')
      //     console.log(res);
      //     console.log('end')
      //     if (typeof __shareData._success === 'function') {
      //       __shareData._success()
      //     }
      //   },
      //   complete: function (res) {
      //     console.log('updateTimelineShareData complete')
      //     console.log(res);
      //     console.log('end')
      //   },
      //   cancel: function (res) {
      //     console.log('updateTimelineShareData cancel')
      //     console.log(res);
      //     console.log('end')
      //   },
      //   fail: function (res) {
      //     console.log('updateTimelineShareData fail')
      //     console.log(res);
      //     console.log('end')
      //   }
      // });
      // wx.updateAppMessageShareData({
      //   title: __shareData.title || "title",
      //   desc: __shareData.desc || "desc",
      //   link: __shareData.link || "link",
      //   imgUrl: __shareData.imgUrl || "imgUrl",
      //   success: function (res) {
      //     console.log('updateAppMessageShareData success')
      //     console.log(res);
      //     console.log('end')
      //     if (typeof __shareData._success === 'function') {
      //       __shareData._success()
      //     }
      //   },
      //   complete: function (res) {
      //     console.log('updateAppMessageShareData complete')
      //     console.log(res);
      //     console.log('end')
      //   },
      //   cancel: function (res) {
      //     console.log('updateAppMessageShareData cancel')
      //     console.log(res);
      //     console.log('end')
      //   },
      //   fail: function (res) {
      //     console.log('updateAppMessageShareData fail')
      //     console.log(res);
      //     console.log('end')
      //   }
      // });
      wx.onMenuShareTimeline({
        title: __shareData.title || "title",
        desc: __shareData.desc || "desc",
        link: __shareData.link || "link",
        imgUrl: __shareData.imgUrl || "imgUrl",
        success: function (res) {
          console.log('onMenuShareTimeline success')
          console.log(res);
          console.log('end')
          if (typeof __shareData._success === 'function') {
            __shareData._success()
          }
        },
        complete: function (res) {
          console.log('onMenuShareTimeline complete')
          console.log(res);
          console.log('end')
        },
        cancel: function (res) {
          console.log('onMenuShareTimeline cancel')
          console.log(res);
          console.log('end')
        },
        fail: function (res) {
          console.log('onMenuShareTimeline fail')
          console.log(res);
          console.log('end')
        }
      });
      wx.onMenuShareAppMessage({
        title: __shareData.title || "title",
        desc: __shareData.desc || "desc",
        link: __shareData.link || "link",
        imgUrl: __shareData.imgUrl || "imgUrl",
        success: function (res) {
          console.log('onMenuShareAppMessage success')
          console.log(res);
          console.log('end')
          if (typeof __shareData._success === 'function') {
            __shareData._success()
          }
        },
        complete: function (res) {
          console.log('onMenuShareAppMessage complete')
          console.log(res);
          console.log('end')
        },
        cancel: function (res) {
          console.log('onMenuShareAppMessage cancel')
          console.log(res);
          console.log('end')
        },
        fail: function (res) {
          console.log('onMenuShareAppMessage fail')
          console.log(res);
          console.log('end')
        }
      });
    });
  });
}

export default updateUpdate



// WEBPACK FOOTER //
// ./src/utils/wxConfig.js